import keys from "config/keys.jsx";
import {
  ApiError,
  buildQueryString,
  buildRequestUrl,
  createApiLogger,
  executeApiRequest,
  interpolateEndpoint
} from "./httpClient";

const clientLogger = createApiLogger("ACADEMY_API_CLIENT");

export { ApiError, buildQueryString, createApiLogger, executeApiRequest, interpolateEndpoint };

export const buildApiUrl = (endpoint, options) => (
  buildRequestUrl(keys.URL, endpoint, options)
);

export const request = (method, endpoint, options = {}) => {
  const { body, payload, logger, ...requestOptions } = options;

  return executeApiRequest(keys.URL, endpoint, {
    ...requestOptions,
    method,
    payload: payload !== undefined ? payload : body,
    logger: logger || clientLogger
  });
};

export const apiClient = {
  get: (endpoint, options) => request("GET", endpoint, options),
  post: (endpoint, payload, options = {}) => request("POST", endpoint, { ...options, payload }),
  put: (endpoint, payload, options = {}) => request("PUT", endpoint, { ...options, payload }),
  patch: (endpoint, payload, options = {}) => request("PATCH", endpoint, { ...options, payload }),
  delete: (endpoint, options) => request("DELETE", endpoint, options),
  upload: (endpoint, formData, options = {}) => request("POST", endpoint, { ...options, payload: formData })
};

export default apiClient;
